module.exports = __webpack_public_path__ + "static/img/service_call.4994bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightSide/service_call.png
// module id = tuZA
// module chunks = 4